import { StringConst } from 'src/app/constants/const';

export class BaseResponseHttp {
  code?: number;
  userError?: any;
  exceptionMessage?: any;
  success?: boolean;
  comments?: any;
}
export interface BaseResponseHttp {
  code?: number;
  userError?: any;
  exceptionMessage?: any;
  success?: boolean;
  comments?: any;
}
export class IErrorHttp {
  error?: MessageError;
  message?: string;
  name?: string;
  ok?: boolean;
  status?: number;
  statusText?: string;
  url?: string;
}
export class MessageError {
  errorCode?: number;
  errorMessage: any;
  info?: string;
  userError?: string;
}

export class ConfirmationChangePageModel {
  title: string;
  message: string;
  extraQuestion?: string;
  closeTrueButton: string;
  closeFalseButton: string;
  constructor() {
    this.title = StringConst.empty;
    this.message = StringConst.empty;
    this.closeTrueButton = StringConst.empty;
    this.closeFalseButton = StringConst.empty;
  }
}
